<template>
  <v-dialog v-model="internalDialogVisible"
            width="600px">
    <v-card>
      <v-card-title class="pb-0 headline">Manage Seat Change Request</v-card-title>
      <v-card-title class="subtitle-2 pt-0 font-weight-light">Required fields are indicated with *</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container class="pl-0">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="pendingRequestCopy.firstName"
                  :rules="[v => !!v || 'First Name is required']"
                  label="First Name *"
                  required />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="pendingRequestCopy.lastName"
                  :rules="[v => !!v || 'Last Name is required']"
                  label="Last Name *"
                  required />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  v-model="pendingRequestCopy.email"
                  :rules="emailRules"
                  label="Email Address" />
              </v-col>
            </v-row>
            <v-row justify="start">
              <v-col cols="auto" class="py-0">
                <v-checkbox v-model="deleteUser" hide-details />
              </v-col>
              <v-col cols="auto" class="pt-4">
                <span class="font-italic">To <span style="font-weight: bold">cancel</span> this pending request, check this box then update request</span>
              </v-col>
            </v-row>
            <v-row>
              <v-alert v-model="showUpdateError" width="576px" type="error" dense outlined prominent dismissible>Error sending seat change addition request, please try again or contact customer support.</v-alert>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn depressed tile color="#004C97" class="text-uppercase white--text" :disabled="!valid || disableSubmit" @click="submit()">Update Request</v-btn>
        <v-btn depressed tile @click="close()">Cancel</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'RemoteAgencyPendingUserEditDialog',
  props: {
    showEditUserDialog: Boolean,
    id: { required: true, type: Number }
  },
  data () {
    return {
      valid: true,
      showUpdateError: false,
      disableSubmit: false,
      pendingRequestCopy: {},
      deleteUser: false,
      emailRules: [
        v => (!!v && /^\S+@\S+\.\S+$/.test(v) && v.length < 141) || 'Email not valid, please enter in the following format: email@domain.com'
      ]
    };
  },
  computed: {
    ...mapState(['agency', 'agencyUser']),
    ...mapGetters(['getPendingSeatManagementRequestById']),
    internalDialogVisible: {
      get: function () {
        return this.showEditUserDialog;
      },
      set: function (visible) {
        if (!visible) {
          this.$emit('close');
        }
      }
    }
  },
  created () {
    this.pendingRequestCopy = Object.assign({}, this.getPendingSeatManagementRequestById(this.id));
  },
  methods: {
    ...mapActions(['updatePendingSeatManagementRequest', 'deletePendingSeatManagementRequest']),
    close: function () {
      this.internalDialogVisible = false;
    },
    async submit () {
      this.disableSubmit = true;

      var response = this.deleteUser ? await this.$api.deleteAgencySeatRequest(this.pendingRequestCopy.id) : await this.$api.updateAgencySeatRequest(this.pendingRequestCopy);
      if (response.code !== 0 && response.code !== 2) {
        this.showUpdateError = true;
        this.disableSubmit = false;
        return;
      }

      if (this.deleteUser) {
        this.deletePendingSeatManagementRequest({ id: this.pendingRequestCopy.id, action: 'add' });
      } else {
        this.updatePendingSeatManagementRequest({ id: this.pendingRequestCopy.id, firstName: this.pendingRequestCopy.firstName, lastName: this.pendingRequestCopy.lastName, email: this.pendingRequestCopy.email });
      }
      this.$emit('success');
      this.$refs.form.reset();
      this.disableSubmit = false;
      this.close();
    }
  }
};
</script>

<style scoped>

</style>
